import {observe} from 'mobx'
import {registerJQueryComponent} from '@lib/JQueryRegistry'

import APIServicesRegistry from '@lib/api-services/APIServicesRegistry'
import ConfigurationAPIService from '@lib/api-services/ConfigurationAPIService'

import configurationStore from '@lib/store/configuration';

export default class SaveConfigurationButton {
    constructor(rootElement) {
        this.$dom = {
            root: rootElement
        }

        this.observer = observe(configurationStore, this.onStoreChange)
        this.$dom.root.click(this.onClick)

        scheduleAtDocumentReady(() => {
            this.configurationAPIService = APIServicesRegistry.getService(ConfigurationAPIService)
        })
    }

    onClick = e => {
        if (!configurationStore.canSave() || configurationStore.hasIssues()) {
            return
        }
        configurationStore.setDuringSave(true);
        $('.page-body-loader').addClass('visible').hide().fadeIn(150)

        this.configurationAPIService.saveNewConfiguration(configurationStore.getTransformedFormModel()).then(() => {
            $('.page-body-loader').fadeOut(150)
            configurationStore.setDuringSave(false);
        }).catch(() => {
            $('.page-body-loader').fadeOut(150)
            configurationStore.setDuringSave(false);
        })
    }

    onStoreChange = change => {
        if (change.object.canSaveConfiguration) {
            this.$dom.root.removeClass('disabled')
        } else {
            this.$dom.root.addClass('disabled')
        }
    }
}

registerJQueryComponent(SaveConfigurationButton, '#configuration-save-button')